import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { selectors as macheteReduxSelectors, utils } from 'src/machete-redux';
import splitDux from 'src/redux/split';
import autobind from 'autobind-decorator';
import { get as lodashGet } from 'lodash';

const EditButton = styled.div`
  position: fixed;
  bottom: 10px;
  left: 350px;
  width: 88px;
  height: 36px;
  padding: 10px;
  line-height: normal;
  letter-spacing: 0.7px;
  text-align: center;
  color: ${({ theme }) => theme.colors.trueBlack};
  ${({ theme }) => theme.mixins.font('medium', 12)}
  border-radius: 2.5px;
  border: solid 1px ${({ theme }) => theme.colors.darkGray3};
  background-color: ${({ theme }) => theme.colors.lightGrayTwo};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.colors.grayButtonHoverBackground};
  }
`;

const mapStateToProps = (state) => ({
  isEditSplitButtonVisible: splitDux.selectors.isEditSplitButtonVisible(state),
  selectedNodeIds: macheteReduxSelectors.segmentation.getSelectedNodeIds(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      handleSplitToolClick: splitDux.actions.handleSplitToolClick,
    },
    dispatch,
  );

export class EditSplitButton extends PureComponent {
  static propTypes = {
    handleSplitToolClick: PropTypes.func.isRequired,
    isEditSplitButtonVisible: PropTypes.bool.isRequired,
    selectedNodeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  };

  @autobind
  handleClick() {
    const { handleSplitToolClick, selectedNodeIds } = this.props;

    const node = utils.getNode(selectedNodeIds[0]);
    const splitNode = node.children.find((child) => child.type === 'split');
    const orientation = lodashGet(
      splitNode.properties.find((property) => property.type === 'orientation'),
      'value',
    );
    handleSplitToolClick({
      nodes: selectedNodeIds,
      orientation,
      isEditing: true,
    });
  }

  render() {
    const { isEditSplitButtonVisible } = this.props;
    if (!isEditSplitButtonVisible) return null;
    return (
      <EditButton data-selenium="editSplitButton" onClick={this.handleClick}>
        Edit Split
      </EditButton>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditSplitButton);
